import { RootState } from '@reducers';

export const selectArticleDetailsPage = (state: RootState) => state.articleDetailsPageReducer;
